import { GsFormFieldSelect, GsFormSchema } from 'libs/shared/src/components';
import { ContentType } from 'libs/shared/src/models';
import { generateSwiperSchemaFields } from '../../basics';
import { ZOOM_SCHEMA_FIELDS } from '../../basics/zoom.schema';
import { ARTICLE_INFO_BASE_FORM_SCHEMA } from './base/article-info-base.schema';

export const ARTICLE_INFO_VOUCHER_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...ARTICLE_INFO_BASE_FORM_SCHEMA,
    ...generateSwiperSchemaFields(false, []),
    ...ZOOM_SCHEMA_FIELDS,
    {
      formControlName: 'voucherMinValue',
      label: 'components.articleInfoVoucher.schema.voucherMinValue',
      type: 'number',
      default: 25
    },
    {
      formControlName: 'voucherMaxValue',
      label: 'components.articleInfoVoucher.schema.voucherMaxValue',
      type: 'number',
      default: 3000
    },
    {
      formControlName: 'segmentBars',
      label: 'components.articleInfo.schema.infoTabs',
      type: 'object-list',
      maxObjectsAmount: 6,
      default: [],
      objectSchema: {
        fields: [
          {
            formControlName: 'name',
            label: 'components.articleInfo.schema.name',
            type: 'text',
            labelPosition: 'left',
            default: 'Tab'
          },
          {
            formControlName: 'contentType',
            label: 'components.articleInfo.schema.contentType',
            type: 'select',
            default: 'details',
            labelPosition: 'left',
            options: [
              { text: 'components.articleInfo.schema.options.details', value: 'details' },
              { text: 'components.articleInfo.schema.options.description', value: 'description' },
              { text: 'components.articleInfo.schema.options.texts', value: 'texts' },
              { text: 'components.articleInfo.schema.options.detailsWithPictograms', value: 'detailsWithPictograms' },
              { text: 'components.articleInfo.schema.options.purchaseArguments', value: 'purchaseArguments' },
              { text: 'components.articleInfo.schema.options.articleProperties', value: 'articleProperties' },
              { text: 'components.articleInfo.schema.options.pictoGrid', value: 'pictoGrid' },
              { text: 'components.articleInfo.schema.options.faq', value: 'faq' },
              { text: 'components.articleInfo.schema.options.ratings', value: 'ratings' }
            ]
          } as GsFormFieldSelect<ContentType>,
          {
            formControlName: 'sortIndex',
            label: 'components.articleInfo.schema.sortIndex',
            type: 'number',
            labelPosition: 'left',
            min: 0,
            default: 0
          }
        ]
      }
    }
  ]
};
